import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import CmsService from 'services/CMS';
import ContentBlock from './ContentBlock'
import style from './style.scss'; //NOSONAR

const GridTwoOverTwo = (props) => {
    const {data, dateServer} = props

    if (!data?.active) return ''

    const [show, setShow] = useState(false)

    useEffect(() => {
        const validateDate = CmsService.validDatesItem(data, dateServer)
        if (validateDate) { setShow(validateDate) }
    }, [])

    const leftBlockData = data.content?.left_block[0] 
    const rightBlockData = data.content?.right_block[0]
    const leftSlot = data.position > 1 ? data.position + 1 : data.position
    const rightSlot = data.position > 1 ? data.position + 2 : data.position + 1

    if (!show) return ''

    return (
        <section className="grid-two-over-two">
            <h1 className="grid-two-over-two-title">{data.title}</h1>
            <div className="grid-two-over-two-scrollable">
                <ContentBlock
                    {...leftBlockData}
                    componentTitle={data.title}
                    slot={leftSlot}
                />
                <ContentBlock
                    {...rightBlockData}
                    componentTitle={data.title}
                    slot={rightSlot}
                />
            </div>
        </section>
    )
}

GridTwoOverTwo.propTypes = {
    data: PropTypes.shape({
        active: PropTypes.bool,
        content: PropTypes.shape({
            left_block: PropTypes.array,
            right_block: PropTypes.array,
        }),
        title: PropTypes.string,
        start_date: PropTypes.string,
        end_date: PropTypes.string,
        position: PropTypes.number,
    }),
    dateServer: PropTypes.number,
}

export default GridTwoOverTwo